import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { close as clearTools, getTools } from '@reducers/clampingTools';
import { connect } from 'react-redux';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { useRoute } from '@react-navigation/native';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import { getPartByID } from '@reducers/parts';
import { getNCFileByPartId } from '@reducers/manufacture';
import { loadSingleBatch } from '@reducers/batch';
import { SingleBatchOrBatchList } from '@v2/pages/common/components/SingleBatchOrBatchList/SingleBatchOrBatchList';
import { LoadSingleBatch } from '@interfaces/methods';
import { parseRouteParamAsNumber } from '@helpers';

interface PartDetailsBatchProps {
  loadSingleBatch: LoadSingleBatch;
}

const PartDetailsBatchComponent: FC<PartDetailsBatchProps> = ({
  getTools,
  clearTools,
  updateHeaderConfig,
  getProductionBatchByPart,
  getPartByID,
  getNCFileByPartId,
  operationsSearch,
  loadSingleBatch,
}) => {
  const title = useTitle();
  const route = useRoute();

  usePartDetails({
    clearTools,
    getTools,
    getProductionBatchByPart,
    updateHeaderConfig,
    getPartByID,
    getNCFileByPartId,
    operationsSearch,
    loadSingleBatch,
  });

  const partId = parseRouteParamAsNumber(route.params?.partId);

  return (
    <DetailsPageWrapper title={title.batch}>
      <SingleBatchOrBatchList fetchBatchList={getProductionBatchByPart} idForGettingBatchList={partId} />
    </DetailsPageWrapper>
  );
};

const PartDetailsBatch = connect(null, {
  getProductionBatchByPart,
  getTools,
  clearTools,
  updateHeaderConfig,
  getPartByID,
  getNCFileByPartId,
  operationsSearch,
  loadSingleBatch,
})(PartDetailsBatchComponent);

export { PartDetailsBatch };
